<template>
  <article>
    <!--바로가기 navi-->
    <div id="accNav">
      <router-link to="#content">본문 바로가기</router-link>
      <router-link to="#footer">푸터 바로가기</router-link>
    </div>

    <header id="header" v-bind:class="{ scroll: scrollPosition > 100 }">
      <div class="header-wrap">
        <div class="inner">
          <h1 class="header-main-logo">
            <router-link to="/main">
              <img
                :src="require('@/assets/images/common/header-main-logo.png')"
                alt="인천통합주차포털"
              />
            </router-link>
          </h1>
          <div class="gnb-wrap">
            <nav class="gnb">
              <ul class="depth01">
                <li
                  v-for="(item, index) in firDepth"
                  :key="index"
                  @click="modalHide"
                  @mouseover="openGnbmenu(item)"
                  @mouseleave="closeGnbmenu(item)"
                >
                  <router-link :to="item.link">{{ item.title }}</router-link>
                  <div class="depth02-wrap" v-if="item.showMenu">
                    <ul class="depth02">
                      <li
                        v-for="(secDepth, index) in item.menuList"
                        :key="index"
                      >
                        <router-link
                          :to="secDepth.link"
                          :class="{
                            link: secDepth.link === '/customer',
                          }"
                          >{{ secDepth.title }}
                        </router-link>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </nav>
            <div class="utill">
              <button
                type="button"
                class="btn-sitemap"
                @click="siteMapBtn"
                :class="{ active: stiemapbtn }"
              >
                <span class="hidden">사이트맵</span>
              </button>
              <button
                type="button"
                class="btn-menu"
                @click="menubtn"
                :class="{ active: btnmenu }"
              >
                <span class="hidden">메뉴</span>
              </button>
            </div>
          </div>
        </div>
      </div>
      <!--모바일 gnb-->
      <nav class="gnb-mobile" v-show="btnmenu">
        <v-expansion-panels>
          <v-expansion-panel v-for="(item, index) in firDepth" :key="index">
            <v-expansion-panel-title>
              {{ item.title }}
            </v-expansion-panel-title>
            <v-expansion-panel-text>
              <v-list>
                <v-list-item
                  v-for="(secDepth, index) in item.menuList"
                  :key="index"
                >
                  <v-list-item-title>
                    <router-link
                      :to="secDepth.link"
                      :class="{
                        link: secDepth.link === '/customer',
                      }"
                      >{{ secDepth.title }}
                    </router-link>
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-expansion-panel-text>
          </v-expansion-panel>
        </v-expansion-panels>
      </nav>
      <!--//모바일 gnb-->

      <!--sitemap-->
      <div class="sitemap" v-show="siteMap">
        <div class="inner">
          <ul class="sitemenu">
            <li v-for="(firDepth, index) in firDepth" :key="index">
              <div class="depth01">
                <p>{{ firDepth.title }}</p>
              </div>
              <ul class="depth02-wrap">
                <li v-for="(secDepth, index) in firDepth.menuList" :key="index">
                  <router-link
                    :to="secDepth.link"
                    class="secTitle"
                    :class="{
                      link: secDepth.link === '/customer',
                    }"
                  >
                    {{ secDepth.title }}
                  </router-link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
      <!--//sitemap-->
    </header>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { cloneDeep } from 'lodash';

export default {
  data() {
    return {
      firDepth: [],
      showMenu: false,
      siteMap: false,
      stiemapbtn: false,
      btnmenu: false,

      scrollPosition: null,

      msg: '',
      alertType: '',
      url: '',
    };
  },

  mounted() {
    window.addEventListener('scroll', this.updateScroll);
  },

  created() {
    this.getGnbMenuList();
  },

  watch: {
    isLogin() {
      this.getGnbMenuList();
    },
    $route() {
      this.btnmenu = false;
      this.siteMap = false;
      this.stiemapbtn = false;
    },
  },

  methods: {
    getGnbMenuList() {
      const copy = cloneDeep(this.menuList);

      this.firDepth = copy.filter(v => {
        if (v.menuList) {
          v.menuList = v.menuList.filter(i => i != '');
        }
        return v;
      });
    },

    // gnbMenu Open
    openGnbmenu(item) {
      item.showMenu = true;
    },

    // gnbMenu Close
    closeGnbmenu(item) {
      item.showMenu = false;
    },

    siteMapBtn() {
      this.siteMap = !this.siteMap;
      this.stiemapbtn = !this.stiemapbtn;
    },

    menubtn() {
      this.btnmenu = !this.btnmenu;
    },

    alertData(msg, alertType, url) {
      this.msg = msg;
      this.alertType = alertType;
      this.url = url;
    },

    setAlertData() {
      this.alertType = '';
    },

    updateScroll() {
      this.scrollPosition = window.scrollY;
    },
  },

  computed: {
    ...mapGetters({
      menuList: 'getMenuList',
    }),
  },
};
</script>
